import { render, staticRenderFns } from "./StoreFileHistory.vue?vue&type=template&id=50544799&scoped=true"
import script from "./StoreFileHistory.vue?vue&type=script&lang=js"
export * from "./StoreFileHistory.vue?vue&type=script&lang=js"
import style0 from "./StoreFileHistory.vue?vue&type=style&index=0&id=50544799&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50544799",
  null
  
)

export default component.exports